import React from "react";
import Chart from "react-apexcharts";
import CurrencyConverter from "@heartinz/currency_subunit_converter";


const processWeeklyData = (saleData) => {
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const processedAmountData = new Array(7).fill(0);
  const processedSalesCountData = new Array(7).fill(0);

  if (!Array.isArray(saleData) || saleData.length === 0) {
    return { processedAmount: processedAmountData,  };
  }

  saleData.forEach(sale => {
    const dayIndex = daysOfWeek.indexOf(sale.dayOfWeek);
    if (dayIndex !== -1) {
      processedAmountData[dayIndex] = CurrencyConverter.toCurrency(sale.totalAmount || 0, "INR");
      processedSalesCountData[dayIndex] = sale.noOfSales;
    }
  });

  return { processedAmount: processedAmountData, };
};

function BiWeeklSaleAnalytics({ AnalyticsData }) {
  
  
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  
  const { processedAmount: thisWeekAmount,  } = processWeeklyData(AnalyticsData?.thisWeek?.saleData ||[]);
  const { processedAmount: lastWeekAmount,  } = processWeeklyData(AnalyticsData?.lastWeek?.saleData)|| [];

  const axisLabelStyle = {
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Inter, sans-serif !important ",
  };

  const axisTitleStyle = {
    fontSize: "14px",
    fontWeight: "500",
    colors: ["#636578"],
    fontFamily: "Inter, sans-serif !important",
  };





  const chartOptions = {
    chart: {
      foreColor: "#9ba7b2",
      height: 360,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.1,
      },
    },
    stroke: {
      width: 5,
      curve: "smooth",
    },
    legend: {
      show: false,
    },
   colors: ["#303f9f", "#9da3cbff"],
    xaxis: {
    categories: daysOfWeek,
      labels: {
        style: {
          colors: ["#888", "#888", "#888", "#888", "#888", "#888", "#888"],
          fontWeight: 600,
        },
      },
      title: {
        text: "Day of the Week",
        style: axisTitleStyle,
      },    
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      {
        seriesName: ["Sale Amount"], 
        // max: Math.round(maxAmount),
        // min: Math.round(minAmount),
  
          tickAmount: 5,
        title: {
          text: "Total Amount",
          style: axisTitleStyle,
        },
        labels: {
          formatter: (value) => Math.round(value || 0),
          style: { ...axisLabelStyle, colors: ["#888888"] },
        },
      },      
    ],
    tooltip: {
      enabled: true,
      theme: "light",    
      y: [
        {
          formatter: (value) => `₹${(value || 0).toLocaleString('en-IN')}`,
          title: {
            formatter: () => "Sale Amount:",
          },
        },
        {
          formatter: (value) => `₹${(value || 0)}`,
          title: {
            formatter: () => "Sale Amount",
          },
        },
      ],
      marker: {
        show: true,
      },
    },
    markers: {
      size: 4,
      colors: ["#303f9f", "#9da3cbff"],
      strokeColors: "#fff",
      strokeWidth: 2,
      fillOpacity: 1,
      shape: "circle",
      radius: 2,
      hover: {
        size: 7,
      },
    },
    grid: {
      row: {
        colors: ["transparent"],
        opacity: 0.5,
      },
    },
  };

  const chartSeries = [
     {
      name: "Last Week Sale Amount",
      type: "line",
      data: lastWeekAmount,
      color: "#9da3cbff",
    }, 
    {
      name: "This Week Sale Amount",
      type: "line",
      data: thisWeekAmount,
      color: "#303f9f",
    },
     
  ];

  const legendItems = [
    { label: "Last Week ", color: "#9da3cbff" }, 
    { label: "This Week ", color: "#303f9f" },
    
  ];


  return (
    <div className="card-body p-0">
      <div className="row row-bordered g-0 h-100">
        <div className="col-md-12 col-12 p-3">
          
            <>
              <div className="d-flex justify-content-end gap-2 flex-wrap mb-3">
                {legendItems.map((item) => (
                  <div
                    className="d-flex justify-content-center align-items-center font-13 gap-1 me-2"
                    key={item.label}
                  >
                    <span
                      style={{
                        width: 12,
                        height: 12,
                        backgroundColor: item.color,
                        borderRadius: "12px",
                      }}
                    />
                    {item.label}
                  </div>
                ))}
              </div>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={300}
              />
            </>         
        </div>
      </div>
    </div>
  );
}

export default BiWeeklSaleAnalytics;